import ReactApexChart from 'react-apexcharts';
import { IPropsDataCotation } from '../../GraphicCotation';
import {
  CardHeaderValue,
  FilterSelect,
  FiltersDate,
  GraphicCotationHistoryContainer,
  HeaderGraphic,
  PercentValue,
  StyledQuoteTable,
  HeaderTopBar,
  PercentValueCumulative,
} from './styles';
import { Info } from '@phosphor-icons/react';
import moment from 'moment';
import { transformMaskCurrency } from '../../../../../utils/transformMaskCurrency';
import { ArrowDown, ArrowUp } from '@phosphor-icons/react';
import ReactLoading from 'react-loading';
import ReactECharts from 'echarts-for-react';
import * as echarts from 'echarts';
import { FormHelperText } from '@material-ui/core';
import { format } from 'date-fns';

interface IPropsGraphicCotationHistory {
  headerValues: {
    annualized_return: number;
    five_year_return: number;
    total_return: number;
    variation: number;
    one_month: number;
    three_months: number;
    six_months: number;
    ten_year_return: number;
  };
  data: IPropsDataCotation[];
  color: string;
  filtersHistoryCotation: {
    period: '1M' | '3M' | '6M' | '1A' | '5A' | '10A' | 'MAX';
  };
  setFiltersHistoryCotation: Function;
  loading: boolean;
}

export function GraphicCotationHistory({
  data,
  headerValues,
  color,
  filtersHistoryCotation,
  setFiltersHistoryCotation,
  loading,
}: IPropsGraphicCotationHistory) {
  const newData = data.map((item) => {
    const date = item.date;

    return date;
  });

  const option = {
    legend: {
      bottom: 17,
    },
    tooltip: {
      trigger: 'axis',
      valueFormatter: (val: any) => transformMaskCurrency(val),

      axisPointer: {
        axis: 'x',
        label: {
          show: true,
          formatter: (val: any) => {
            return moment(val.value).format('L');
          },
        },
      },
    },
    grid: {
      // containLabel: true,
      height: 'auto',
      width: 'auto',
    },
    toolbox: {
      feature: {
        dataZoom: {
          yAxisIndex: 'none',
        },
        restore: {},
        saveAsImage: {},
      },
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: newData,

      axisLabel: {
        interval: function (index: number, value: string) {
          const lastIndex = newData.length - 1;
          // Exibir apenas algumas datas + sempre a última
          return (
            index % Math.ceil(newData.length / 6) === 0 || index === lastIndex
          );
        },
        formatter: function (value: any, index: number) {
          if (filtersHistoryCotation.period) {
            return moment(value).format('MMM/YYYY');
          } else {
            return moment(value).format('DD MMM');
          }
        },
      },
      label: {
        show: true,
      },
    },
    yAxis: {
      type: 'value',

      min: function (value: any) {
        return value.min - 5;
      },
      axisLabel: {
        formatter: function (value: any, index: number) {
          return transformMaskCurrency(value);
        },
      },
    },

    series: [
      {
        name: 'Fechamento',
        type: 'line',
        symbol: 'none',
        sampling: 'lttb',
        itemStyle: {
          color: '#3cd2f7',
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: '#5adbfb',
            },
            {
              offset: 1,
              color: '#3cd2f7',
            },
          ]),
        },

        data: data.map((item) => item?.close),
      },
    ],
  };

  return (
    <GraphicCotationHistoryContainer>
      <HeaderTopBar>
        <HeaderGraphic>
          {/* Cotação atual e variação */}
          <div className='fechamento'>
            {data[data.length - 1]?.date && (
              <FormHelperText>
                Fechamento de{' '}
                <b>{moment(data[data.length - 1]?.date).format('L')}</b>
              </FormHelperText>
            )}
            <h1>
              {transformMaskCurrency(data[data.length - 1]?.close ?? 0)}{' '}
            </h1>
              <PercentValue upValue={headerValues.variation > 0}>
                <p className='text-variation'>
                  *Variação
                  <br/>da <b style={{borderBottom:'none',}}>Cotação</b>
                </p>
                {headerValues.variation > 0 ? <ArrowUp /> : <ArrowDown />}
                {headerValues?.variation ? headerValues?.variation.toFixed(2) : 0}%
              </PercentValue>
          </div>
          {/* Filtros de Período */}
          <FiltersDate>
            {['1M', '3M', '6M', '1A', '5A', '10A', 'MAX'].map((periodo) => (
              <FilterSelect
                key={periodo}
                isSelected={filtersHistoryCotation.period === periodo}
                onClick={() => setFiltersHistoryCotation({ period: periodo })}
              >
                {periodo === '1M'
                  ? '1 Mês'
                  : periodo === '3M'
                  ? '3 Meses'
                  : periodo === '6M'
                  ? '6 Meses'
                  : periodo === '1A'
                  ? '1 Ano'
                  : periodo === '5A'
                  ? '5 Anos'
                  : periodo === '10A'
                  ? '10 Anos'
                  : 'Max'}
              </FilterSelect>
            ))}
          </FiltersDate>
        </HeaderGraphic>
          {/* Tabela de Percentual Acumulado */}
          <StyledQuoteTable>
            <table>
              <thead>
                <tr>
                  <th>
                    Percentual acumulado{" "}
                    <span title="Consideramos Desdobramentos, Agrupamentos e Dividendos nesse Percentual.">
                      <Info size="1rem" color="#EC6643" />
                    </span>
                  </th>
                  <th>Período</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <PercentValueCumulative upValue={headerValues.one_month > 0}>
                      {headerValues.one_month > 0 ? <ArrowUp /> : <ArrowDown />}
                      {headerValues?.one_month ? headerValues?.one_month.toFixed(2) : 0}%
                    </PercentValueCumulative>
                  </td>
                  <td>1 mês</td>
                </tr>
                <tr>
                  <td>
                    <PercentValueCumulative upValue={headerValues.three_months > 0}>
                      {headerValues.three_months > 0 ? <ArrowUp /> : <ArrowDown />}
                      {headerValues?.three_months ? headerValues?.three_months.toFixed(2) : 0}%
                    </PercentValueCumulative>
                  </td>
                  <td>3 meses</td>
                </tr>
                <tr>
                  <td>
                    <PercentValueCumulative upValue={headerValues.six_months > 0}>
                      {headerValues.six_months > 0 ? <ArrowUp /> : <ArrowDown />}
                      {headerValues?.six_months ? headerValues?.six_months.toFixed(2) : 0}%
                    </PercentValueCumulative>
                  </td>
                  <td>6 meses</td>
                </tr>
                <tr>
                  <td>
                    <PercentValueCumulative upValue={headerValues.annualized_return > 0}>
                      {headerValues.annualized_return > 0 ? <ArrowUp /> : <ArrowDown />}
                      {headerValues?.annualized_return ? headerValues?.annualized_return.toFixed(2) : 0}%
                    </PercentValueCumulative>
                  </td>
                  <td>12 meses</td>
                </tr>
                <tr>
                  <td>
                    <PercentValueCumulative upValue={headerValues.five_year_return > 0}>
                      {headerValues.five_year_return > 0 ? <ArrowUp /> : <ArrowDown />}
                      {headerValues?.five_year_return ? headerValues?.five_year_return.toFixed(2) : 0}%
                    </PercentValueCumulative>
                  </td>
                  <td>5 anos</td>
                </tr>
                <tr>
                  <td style={{ borderBottom: 'none' }}>
                    <PercentValueCumulative upValue={headerValues.ten_year_return > 0}>
                      {headerValues.ten_year_return > 0 ? <ArrowUp /> : <ArrowDown />}
                      {headerValues?.ten_year_return ? headerValues?.ten_year_return.toFixed(2) : 0}%
                    </PercentValueCumulative>
                  </td>
                  <td style={{ borderBottom: 'none' }}>10 anos</td>
                </tr>
              </tbody>
            </table>
          </StyledQuoteTable>

      </HeaderTopBar>
      {/* Excluído o antigo */}

      {loading ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem',
          }}
        >
          <ReactLoading
            color="var(--primary)"
            type="spinningBubbles"
            width={120}
            height={120}
          />
        </div>
      ) : (
        <ReactECharts option={option} notMerge={true} />
      )}
    </GraphicCotationHistoryContainer>
  );
}
